// @flow
/* eslint-disable */

import _ from 'lodash';
import React, { memo } from 'react';
import { isRTL } from 'app/utils/lang';
import Styles from './styles';
import defaultBG from './assets/default.png';
import upBG from './assets/up.png';
import rightBG from './assets/right.png';
import leftBG from './assets/left.png';
import downBG from './assets/down.png';
import okBG from './assets/ok.png';

type Props = {
  onLeft : () => void,
  onRight : () => void,
  onUp : () => void,
  onDown : () => void,
  onOk : () => void,
};

export default memo(({
  onLeft,
  onRight,
  onUp,
  onDown,
  onOk,
} : Props) => {
  const pathname = _.get(window, ['location', 'pathname'], '/');
  const urlPath = pathname.split('/')[2];
  return (
    <Styles
      backgroundImage={defaultBG}
      upBackgroundImage={upBG}
      rightBackgroundImage={rightBG}
      leftBackgroundImage={leftBG}
      downBackgroundImage={downBG}
      okBackgroundImage={okBG}
      className={`${isRTL() ? 'rtl' : ''}${(!!urlPath && (urlPath === 'w' || urlPath === 'details' || urlPath === 'l' || urlPath === 'c' || urlPath === 'payment')) ? `${isRTL() ? ' ' : ''}hide` : ''}`}
    >
      <span tabIndex="-1" className="up" onClick={onUp} />
      <span tabIndex="-1" className="right" onClick={isRTL() ? onRight : onLeft} />
      <span tabIndex="-1" className="down" onClick={onDown} />
      <span tabIndex="-1" className="left" onClick={isRTL() ? onLeft : onRight} />
      <span tabIndex="-1" className="ok" onClick={onOk} />
    </Styles>
  );
});
